// extracted by mini-css-extract-plugin
export default {"text":"warehouse-size_text__AxrOA","value":"warehouse-size_value__awezw","msg":"warehouse-size_msg__PxJbK"};